export enum JobTypesEnum {
    MAIN_JOB = 'Main Job',
    SUB_JOB = 'Sub Job',
    NO_DOC = 'No Doc',
}